import React from 'react';
import { useTranslation } from 'react-i18next';
import { Patient } from '../../types/firestoreTypes';
import { Mail, MailCheck } from 'lucide-react';

interface PatientReviewEmailStatusProps {
 patient: Patient;
 className?: string;
}

export const PatientReviewEmailStatus: React.FC<PatientReviewEmailStatusProps> = ({ 
 patient, 
 className = '' 
}) => {
 const { t, i18n } = useTranslation();

 const formatDate = (timestamp: any) => {
   if (!timestamp) return '';
   
   // Handle Firestore Timestamp
   const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
   
   return date.toLocaleDateString(i18n.language === 'hu' ? 'hu-HU' : 'en-US', {
     year: 'numeric',
     month: 'short',
     day: 'numeric'
   });
 };

 if (patient.reviewEmailSent) {
   return (
     <div className={`flex items-center gap-2 text-green-600 ${className}`}>
       <MailCheck className="h-4 w-4" />
       <div className="flex flex-col">
         <span className="text-sm font-medium">
           {t('patient.reviewEmail.sent', { date: formatDate(patient.reviewEmailSentAt) })}
         </span>
         {patient.reviewEmailSentAfterSession && (
           <span className="text-xs text-green-500">
             {t('patient.reviewEmail.afterSession', { sessionCount: '5+' })}
           </span>
         )}
       </div>
     </div>
   );
 }

 return (
   <div className={`flex items-center gap-2 text-gray-500 ${className}`}>
     <Mail className="h-4 w-4" />
     <span className="text-sm">
       {t('patient.reviewEmail.notSent')}
     </span>
   </div>
 );
}; 